<template>
	<section class="resource-section-row">
		<div class="b360-container-row">
			<h1>{{ Header }}</h1>
			<section :class="`description-row-content ${className}`">
				<p class="description">{{ Subheader }}</p>
			</section>
		</div>

		<section class="resource-content-row">
			<article
				v-for="item in content"
				class="resource-content-col"
				:key="item.id"
			>
				<ResourceCard :item="item" :className="className" />
			</article>
		</section>
	</section>
</template>

<script>
import ResourceCard from '@/components/cards/ResourceCard.vue';

export default {
	name: 'ResourceSectionGrid',
	components: {
		ResourceCard,
	},
	props: {
		Header: String,
		Subheader: String,
		content: Array,
		className: String,
	},
};
</script>

<style lang="scss" scoped>
section.resource-section-row {
	border: 1px solid $border-color-light;
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: $off-white;

	h1 {
		margin-bottom: unset;
	}

	.description-row-content {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		@include rem(margin-bottom, 30px);

		&:not(.whats-new) {
			margin-top: -19px;

			@include mobile {
				margin-top: unset;
			}
		}

		p.description {
			@include rem(max-width, 1050px);
			@include rem(width, 100%);
			@include rem(margin, 20px 0 0);
			@include rem(font-size, 15px);
		}
	}
}

.resource-content-row {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}

.resource-content-col {
	margin-right: unset;
	transform: scale(1);
	height: 100%;
	position: relative;
	box-sizing: border-box;
	@include rem(margin-left, 30px);
	border: 2px solid transparent;
	transition: all $b360-motion-duration--long $b360-motion-easing--accelerate;

	&:hover {
		transform: scale(1.05);
	}

	@include phablet {
		margin-left: unset;
		@include rem(margin-right, 25px);
	}

	@include mobile {
		margin-right: unset;
	}
}
</style>
